import { Component, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { FormArray, FormControl, AbstractControl } from '@angular/forms';
import { LookupViewModel } from '../../view-models/lookup.view-model';

@Component({
  selector: 'ndms-radio',
  templateUrl: './ndms-radio.component.html',
  styleUrls: ['./ndms-radio.component.scss']
})
export class NdmsRadioComponent extends NdmsFormControlComponent implements OnInit {
  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
  }

  initChecked(item: LookupViewModel) {
    let formControl = (this.hasFormComponent.form.get(this.field) as FormControl);
    return formControl && formControl.value && formControl.value.key === item.key;
  }
  
  onCheckedChange(event, item) {
    let formControl: FormControl = this.hasFormComponent.form.get(this.field) as FormControl;

    if(event.target.checked) {
      formControl.setValue(item);
    }
  }

  getText() {
    if (!this.value || !this.value.key) {
      return 'N/A';
    }
    return this.value.description;
  }
}
